import * as L from '@loomhq/lens';

import copy from 'copy-to-clipboard';
import * as clipboard from 'utilities/clipboard';
import { getAnimatedPreview, getAliasVideoUrl } from 'utilities/video';

import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { LOOM_URI } from '../../../../constants/routes';

import styles from './styles.module.less';

const vanillaKey = id => `${id}-vanilla-link`;
const emailKey = id => `${id}-email-link`;

const GifMarkup = ({ video, id }) => {
  const gif = getAnimatedPreview(video);
  const url = getAliasVideoUrl(id);

  return (
    <a href={url} title="Watch Loom Video">
      <p>
        {video.name} &mdash; Watch Video
        <br />
        <br />
      </p>
      <img style={{ maxWidth: '300px' }} src={gif} />
    </a>
  );
};

const SalesforceEmailsList = ({ fromModal, deleteLinkHandler = null }) => {
  const [copied, setCopied] = useState(null);

  const { shareVideoAliases, video } = useSelector(state => state.share_video);

  const triggerCopyState = key => {
    setCopied(key);

    // Reset back to default state after 3 seconds
    setTimeout(() => {
      setCopied(null);
    }, 3000);
  };

  if (!shareVideoAliases.length) {
    return null;
  }

  const baseControls = [
    [
      () => <L.SvgCode />,
      ({ id }) =>
        emailKey(id) === copied ? 'Copied' : 'Copy Linked GIF for email',
      ({ id }) =>
        () => {
          clipboard.copyComponent(() => <GifMarkup {...{ id, video }} />);

          triggerCopyState(emailKey(id));
        },
    ],
    [
      () => <L.SvgLink />,
      ({ id }) =>
        vanillaKey(id) === copied ? 'Link Copied' : 'Copy video link',
      ({ id }) =>
        () => {
          const url = `${LOOM_URI}/a/${id}`;

          copy(url, { format: 'text/plain' });

          triggerCopyState(vanillaKey(id));
        },
    ],
  ];

  const deleteControl = [
    () => <L.SvgTrash />,
    () => 'Delete',
    ({ id, email }) =>
      () =>
        deleteLinkHandler({ id, email }),
  ];

  const controls =
    fromModal === true ? [...baseControls, deleteControl] : baseControls;

  const buildControlIcon =
    payload =>
    ([iconFn, nameFn, buildOnClick]) => {
      const name = nameFn(payload);

      return (
        <L.Tooltip content={name}>
          <L.IconButton
            key={`${payload.id}-${name}`}
            size="small"
            icon={iconFn()}
            altText={name}
            onClick={buildOnClick(payload)}
          />
        </L.Tooltip>
      );
    };

  return (
    <>
      <L.List columns={['1fr', 'auto']} gap="medium">
        {shareVideoAliases.map(payload => {
          const { id, email } = payload;

          return (
            <L.ListRow padding={fromModal ? 'small' : 'xsmall'} key={id}>
              <L.Text hasEllipsis>{email}</L.Text>
              <div className={styles.emailActions}>
                <L.Distribute gap="small">
                  {controls.map(buildControlIcon(payload))}
                </L.Distribute>
              </div>
            </L.ListRow>
          );
        })}
      </L.List>
    </>
  );
};

export default SalesforceEmailsList;
